import React, { memo, useEffect, useRef } from 'react';
import { EditorContent, useEditor } from '@tiptap/react';
import styles from './TiptapEditor.module.scss';
import './TiptapEditor.scss';
import classNames from 'classnames';
import { feedbackEditorExtensionsH5 } from '../../../components/feedbackEditorExtensions';
import { replaceEmojiCodes } from '../../../../../utils/emoji';
import { px2rem } from '@utils/px2rem';
import { prepareEditorHtmlForHydration } from '../../../../../utils/tiptapEditorContent';

interface TiptapEditorH5Props {
    initialContent?: string;
    onContentChange?: (content: string) => void;
    editorRef?: React.MutableRefObject<any>;
    type?: 2;
    emojiList?: any[];
}

const TiptapEditorH5: React.FC<TiptapEditorH5Props> = ({
    initialContent = '',
    onContentChange,
    editorRef,
    type,
    emojiList,
}) => {
    const onContentChangeRef = useRef(onContentChange);
    const lastHydratedSourceRef = useRef<string | null>(null);
    const lastHydratedHtmlRef = useRef<string>('');
    onContentChangeRef.current = onContentChange;

    const editor = useEditor({
        extensions: feedbackEditorExtensionsH5,
        content: prepareEditorHtmlForHydration(initialContent),
        onUpdate: ({ editor: ed }) => {
            onContentChangeRef.current?.(ed.getHTML());
        },
        editorProps: {
            attributes: {
                class: 'tiptap-editor-content',
            },
        },
    }, []);

    useEffect(() => {
        if (editorRef) {
            editorRef.current = editor;
        }
    }, [editor, editorRef]);

    // 仅在外部内容切换，或编辑器仍停留在上次回填结果时，才同步回编辑器。
    // 这样 emojiList 异步到达时不会覆盖用户刚输入的内容。
    useEffect(() => {
        if (!editor) return;

        const parsedContent = prepareEditorHtmlForHydration(replaceEmojiCodes(initialContent, emojiList));
        const currentHtml = editor.getHTML();
        const sourceChanged = lastHydratedSourceRef.current !== initialContent;
        const editorMatchesLastHydrated = currentHtml === lastHydratedHtmlRef.current;

        if ((sourceChanged || editorMatchesLastHydrated) && currentHtml !== parsedContent) {
            editor.commands.setContent(parsedContent, { parseOptions: { preserveWhitespace: 'full' } });
        }

        lastHydratedSourceRef.current = initialContent;
        lastHydratedHtmlRef.current = parsedContent;
    }, [initialContent, editor, emojiList]);

    return (
        <div className={classNames(styles.editorWrapper, 'editor-h5' )} style={{minHeight: type == 2 ? px2rem(200) : ''}}>
            <EditorContent editor={editor} />
        </div>
    );
};

export default memo(TiptapEditorH5);
